import { defineStore } from "pinia";

export type TFaqItem = {
  attributes: {
    text: string;
    title: string;
    updatedAt: string;
  };
  id: number;
};

export type TFaqCategory = {
  attributes: {
    description: string;
    faq_items: {
      data: TFaqItem[];
    };
    slug: string;
    title: string;
    updatedAt: string;
  };
  id: number;
};

export type TFaqState = {
  data: {
    data?: TFaqCategory[];
  } | null;
  pending: boolean;
  error: any;
};

export type TLocaleFaq =
  | "en"
  | "it"
  | "bg"
  | "de"
  | "es"
  | "fr"
  | "hi"
  | "ja"
  | "pt"
  | "ru"
  | "tr"
  | "th"
  | "uk"
  | "zh"
  | null;

export const useFaqStore = defineStore("faq", {
  state: () =>
    ({
      data: null,
      pending: true,
      error: null,
    }) as TFaqState,

  getters: {
    faqItems(state) {
      return state.data?.data;
    },
  },
  actions: {
    async fetchFaq(locale: TLocaleFaq = null) {
      this.data = null;
      this.pending = true;
      try {
        const reqParams = {
          sort: "position",
          fields: ["title", "slug", "updatedAt", "description", "order"],
          "populate[faq_items][populate]": "*",
          locale: locale,
        };

        this.data = await $fetch("/api/faq-categories", { params: reqParams });

        if (this.faqItems && this.faqItems.length === 0) {
          this.data = await $fetch("/api/faq-categories", {
            params: { ...reqParams, locale: "en" },
          });
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.pending = false;
      }
    },
    getFaqItem(slug: string) {
      const items = this.faqItems || [];

      for (const item of items) {
        if (item?.attributes?.slug.includes(slug)) {
          return item;
        }
      }
    },
  },
});
